import { SettingsRoomsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import RoomCategoryModel, {
  RoomCategoryCreateModel,
} from "models/Settings/Rooms/RoomCategoryModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";
import { sprintf } from "sprintf-js";

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<RoomCategoryModel[]> => {
    return await axios
      .get(SettingsRoomsEndpoint.ROOMS_CATEGORY, { params })
      .then(({ data }) => data.items);
  };

export const getOne =
  (axios: AxiosInstance) =>
  async (id: number | string): Promise<RoomCategoryModel> => {
    return await axios
      .get(sprintf(SettingsRoomsEndpoint.ROOMS_CATEGORY_ID, id))
      .then(({ data }) => data);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: RoomCategoryCreateModel): Promise<RoomCategoryModel> => {
    return await axios
      .post(SettingsRoomsEndpoint.ROOMS_CATEGORY, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: RoomCategoryModel): Promise<RoomCategoryModel> => {
    return await axios
      .put(sprintf(SettingsRoomsEndpoint.ROOMS_CATEGORY_ID, data.id), data)
      .then(({ data }) => data);
  };

export const patch =
  (axios: AxiosInstance) =>
  async (data: Partial<RoomCategoryModel>): Promise<RoomCategoryModel> => {
    return await axios
      .patch(sprintf(SettingsRoomsEndpoint.ROOMS_CATEGORY_ID, data?.id!), data)
      .then(({ data }) => data);
  };

export const remove =
  (axios: AxiosInstance) =>
  async (id: number | string): Promise<RoomCategoryModel> => {
    return await axios
      .delete(sprintf(SettingsRoomsEndpoint.ROOMS_CATEGORY_ID, id))
      .then(({ data }) => data);
  };
